var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"value":_vm.value.auditStatuses,"label":_vm.$t('label.info.auditStatus'),"items":_vm.autocompletion.auditStatuses,"multiple":"","clearable":"","hide-details":""},on:{"input":function($event){return _vm.updateFilter('auditStatuses', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }